/**
 * Module dependencies.
 */

import React, { type ComponentPropsWithoutRef } from 'react';
import { cn } from 'app/lib/utils';

/**
 * Export `Wrapper` component.
 */

export function Wrapper({ className, ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('mb-4 rounded-md border border-border p-4', className)} {...rest} />;
}

/**
 * Export `HeaderForm` component.
 */

export function HeaderForm({ className, ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('-mx-4 -mt-4 flex flex-row gap-4 bg-muted p-4', className)} {...rest} />;
}

/**
 * Export `TransactionsWrapper` component.
 */

export function TransactionsWrapper({ className, ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('p-4', className)} {...rest} />;
}

/**
 * Export `StatusWrapper` component.
 */

export function StatusWrapper({ className, ...rest }: ComponentPropsWithoutRef<'div'>) {
  return <div className={cn('mx-8 mt-8 flex flex-row rounded-lg bg-muted p-4', className)} {...rest} />;
}
